module.exports = __webpack_public_path__ + "img/test-xiayizhang.27cbf362.png";